/**
 * 연결 유형(dev/prod/edu) 공용 정의.
 *
 * 원래 ConnectionModal 안에만 있던 CONN_TYPES 를 밖으로 뺐다.
 * 헤더 색상 띠·실행 안전장치가 같은 정의를 봐야 "운영인데 파란색" 같은 어긋남이 안 생긴다.
 */

// 모듈 스코프라 useTranslation() 을 쓸 수 없다. 문구 대신 **키**를 담고,
// 화면에 그릴 때 컴포넌트에서 t(labelKey) 로 번역한다.
// 키는 ConnectionModal 이 쓰던 connection 네임스페이스를 그대로 재사용한다 —
// 같은 문구를 두 벌 관리하면 반드시 어긋난다.
// darkColor — 어두운 배경에 글자·테두리로 쓸 때의 색. color 그대로면 개발(#007bff)이 거의 안 보였다
// (사용자 지적 2026-09-13). 같은 계열에서 밝기만 올린다 — 색이 바뀌면 "운영인데 파란색" 류 혼동이 생긴다.
export const CONN_TYPES = [
  { value: 'prod', labelKey: 'connection:connType.prod', color: '#dc3545', darkColor: '#ff6b6b', descKey: 'connection:connType.prodDesc' },
  { value: 'dev',  labelKey: 'connection:connType.dev',  color: '#007bff', darkColor: '#6cb6ff', descKey: 'connection:connType.devDesc' },
  { value: 'edu',  labelKey: 'connection:connType.edu',  color: '#28a745', darkColor: '#5dd27f', descKey: 'connection:connType.eduDesc' },
];

const BY_VALUE = CONN_TYPES.reduce((acc, ct) => { acc[ct.value] = ct; return acc; }, {});

/** 유형 메타 조회 — 미지정/미지 값은 dev 로 본다(기존 기본값과 동일). */
export function getConnType(value) {
  return BY_VALUE[value] || BY_VALUE.dev;
}

/**
 * 유형 색을 **CSS 변수로** 넘긴다(인라인 style 에 펼쳐 쓴다).
 * 인라인 `color` 로 직접 칠하면 CSS 가 다크모드에서 바꿀 수 없다 — 변수만 넘기고 실제 색은 CSS 가 고른다
 * (`var(--conn-color)` / 다크: `var(--conn-color-dark)`).
 */
export function connTypeColorVars(ct) {
  if (!ct) return {};
  return { '--conn-color': ct.color, '--conn-color-dark': ct.darkColor || ct.color };
}

/** 운영 연결인가 — 실행 안전장치의 판단 기준. */
export function isProduction(value) {
  return value === 'prod';
}
